<template>
    <div class="relative">
        <div class="code">
            <p class="img"><qriously :value="task_url" :size="160" /></p>
            <p class="text">微信扫一扫分享给朋友</p>
        </div>
        <div class="manage-title"><em class="txt">订单信息</em></div>
        <div class="infoBox margin-top-20">
            <div class="item flex">
                <p class="tit">订单标题</p>
                <p class="txt">{{task_title}}</p>
            </div>
            <div class="item flex">
                <p class="tit">赏金金额</p>
                <p class="txt">￥{{money}}</p>
            </div>
            <div class="item flex">
                <p class="tit">奖励类型</p>
                <p class="txt" v-if="reward_type == 0">赏金</p>
                <p class="txt" v-if="reward_type == 1">优惠券</p>
                <p class="txt" v-if="reward_type == 2">体验卡</p>
                <p class="txt" v-if="reward_type == 3">实物</p>
                <p class="txt" v-if="reward_type == 4">抽奖次数</p>
            </div>
            <div class="item flex">
                <p class="tit">点击量任务</p>
                <p class="txt">{{task_click}}</p>
            </div>
            <div class="item flex">
                <p class="tit">订单编号</p>
                <p class="txt">{{order_sn}}</p>
            </div>
            <div class="item flex">
                <p class="tit">接单时间</p>
                <p class="txt">{{receipt_time}}</p>
            </div>
            <div class="item flex">
                <p class="tit">开始时间</p>
                <p class="txt">{{task_receipt_time}}</p>
            </div>
            <div class="item flex">
                <p class="tit">结束时间</p>
                <p class="txt">{{task_time}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ExtensionInfo',
    props: {
        task_title: String,
        money: String,
        task_click: String,
        order_sn: String,
        receipt_time: String,
        task_receipt_time: String,
        task_time: String,
        task_url: String,
        reward_type: String,
    }
}
</script>
<style scoped>
    .code{position: absolute;right:50px;top:50px;}
    .code .img img{width:150px;height:150px;}
    .code .text{text-align: center;}
</style>
